// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__ncjMU","buttons":"PendingPaymentAlert_buttons__ncHCb"};